/**
 * Created by JackCui on 2022/10/11
 */
import api from './api'
import response from '../../../utils/response'
import {FIELD_TYPE, HEADER_PARAMS_KEYS, PROJECT_CODE, FIELD_VALUE_TYPE} from '../../constants'

const quoteFieldRequest = (params) => {
  const {url, type} = api.getQuoteField
  return response({
    method: type,
    url,
    params,
    headerParams: {
      [HEADER_PARAMS_KEYS.tenantType]: PROJECT_CODE
    },
    option: {
      showError: false
    }
  })
}

const quoteFieldHandle = ({schema, subSchema = []}) => {
  const objectParams = {}
  const process = (_) => {
    const {fields} = _.data
    const quoteFieldList = fields.filter(
      v =>
        v.type === FIELD_TYPE.QUOTE &&
        v?.relateFieldClassification === FIELD_VALUE_TYPE.OBJECT
    )

    quoteFieldList.forEach(v => {
      if (!objectParams[v.relateObjectApiName]) {
        objectParams[v.relateObjectApiName] = []
      }
      objectParams[v.relateObjectApiName].push(v.relateFieldApiName)
    })
    return objectParams
  }
  const queryParams = []

  ~(
    [schema, ...subSchema].map(v => process(v))
  )

  for (let k in objectParams) {
    queryParams.push({
      objectApiName: k,
      fieldApiNameList: objectParams[k]
    })
  }
  return queryParams
}

// 批量处理主从对象的引用字段
export const batchQuoteFieldsHandle = async (schemas) => {
  const {schema, subSchema = []} = schemas
  const params = quoteFieldHandle(schemas)

  if (!params.length) {
    return
  }

  const {isOk, content} = await quoteFieldRequest(params)

  if (!isOk) {
    return
  }

  [schema, ...subSchema].forEach(v => {
    v.data.quoteFieldsMap = content
  })
}
